import React from 'react';
import Routes from './Routes';
import PropTypes from 'prop-types';
import {Loader} from '../Loading';

class AccountApp extends React.Component {
  componentDidMount() {
    this.props.loadData();
  }

  componentWillReceiveProps({ userId: newUserId, loadData }) {
    const { userId } = this.props;
    if (newUserId !== userId) {
      loadData();
    }
  }
  render() {
    const {
      user, 
      account,
      products
    } = this.props;

    if( !user || !account || !products ) {
      return <Loader />
    }
    return <Routes {...this.props} />;
  }
}

AccountApp.propTypes = {
  user: PropTypes.object,
  account: PropTypes.object,
  products: PropTypes.array,
  userId: PropTypes.string.isRequired,
  loadData: PropTypes.func.isRequired
}

export default AccountApp;


// WEBPACK FOOTER //
// ./src/components/accounts/AccountApp.js